<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Business Class
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.paramName }}</td>
                <td class="text-xs-left">{{ row.item.paramSub }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.paramName)"
                    query
                    @query="doQuery(row.item.paramName)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { polTypeDataMixin } from '@/mixins/params/polTypeDataMixin'

export default {
  data() {
    return {
      headers: [{ text: 'Policy Type', value: 'paramName' }, { text: 'Business Class', value: 'paramSub' }, TableConst.tableActionHeader],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    doNew() {},
    doQuery() {},
    doReview() {}
  },
  created() {
    this.doInit('polTypeBusCls')
  },
  mixins: [TableConst.default, polTypeDataMixin]
}
</script>
